var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBlogSocialMediaX(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 36,
    viewBox: "0 0 37 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.1151 8H27.6419L19.9368 16.8064L29.0012 28.7899H21.9039L16.345 21.5219L9.98435 28.7899H6.4554L14.6967 19.3705L6.00122 8H13.2787L18.3035 14.6432L24.1151 8ZM22.8773 26.6789H24.8315L12.2169 10.0001H10.1197L22.8773 26.6789Z",
    fill: "#787879"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlogSocialMediaX);
export default __webpack_public_path__ + "static/media/blog-social-media-x.3599fa79b62780d39e1e734bb3038cdb.svg";
export { ForwardRef as ReactComponent };